module.exports = __webpack_public_path__ + "img/press-logos-mobile.73635760.png";